import { render, staticRenderFns } from "./BaseFormSelect.vue?vue&type=template&id=106eb716"
import script from "./BaseFormSelect.vue?vue&type=script&lang=js"
export * from "./BaseFormSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports